import { render, staticRenderFns } from "./leaveRequestold.vue?vue&type=template&id=f9bbb980&"
import script from "./leaveRequestold.vue?vue&type=script&lang=js&"
export * from "./leaveRequestold.vue?vue&type=script&lang=js&"
import style0 from "./leaveRequestold.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports